"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Portal_1 = __importDefault(require("@material-ui/core/Portal"));
var Portal = function (_a) {
    var container = _a.container, disablePortal = _a.disablePortal, onRendered = _a.onRendered, children = _a.children;
    return (react_1.default.createElement(Portal_1.default, { container: container, disablePortal: disablePortal, onRendered: onRendered }, children));
};
exports.default = Portal;
